import { render, staticRenderFns } from "./GeneralDataMainView.vue?vue&type=template&id=145e09d4"
import script from "./GeneralDataMainView.vue?vue&type=script&lang=js"
export * from "./GeneralDataMainView.vue?vue&type=script&lang=js"
import style0 from "./GeneralDataMainView.vue?vue&type=style&index=0&id=145e09d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports